<template>
  <div
    class="form-group wordcloud-input"
    :class="{ error: !slideActive.entriesPerParticipant }"
  >
    <label class="label-option">
      {{ $i18nPresenter.t('Entries per participant') }}
      <span class="title-table-presentation-tooltip result-layout-tooltip">
        <b-button
          v-tooltip="$i18nPresenter.t('One entry can consist of several words. You can increase this limit to 10')"
          class="tooltip-btn"
        />
        <i class="fas fa-question-circle" />
      </span>
    </label>
    <input
      type="number"
      class="form-control"
      v-model="slideActive.entriesPerParticipant"
      @input="$emit('updateSettingSlide', 9)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
  },
}
</script>

<style lang="scss" scoped>
.wordcloud-input {
  input {
    width: 70px;
  }
}
</style>
